import { useState } from 'react';
import { Link } from 'react-router-dom';
import { GroupForm } from '../features/Inquiry/GroupForm';
import { GroupSidePanel } from '../features/Inquiry/SidePanel';
import { ApiError, postJson } from '../lib/api/client';
import styles from './GroupInquiryPage.module.css';
import { Seo } from '../components/Seo';
import { breadcrumbJsonLd } from '../lib/structuredData';

export function GroupInquiryPage() {
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (payload) => {
    setIsSubmitting(true);
    setErrorMessage('');
    try {
      await postJson('/apis/consult', payload);
      setSubmitted(true);
    } catch (err) {
      const msg = err instanceof ApiError ? err.message : '네트워크 오류가 발생했습니다.';
      setErrorMessage(msg);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className={styles.main}>
      <Seo
        title="단체·기관 법률 자문 계약 — medilawyer"
        description="의사회, 전문학회, 네트워크 의원 본사 등 의료인 단체를 위한 맞춤형 법률 자문 계약. 규모와 필요에 따라 조건을 협의해 드립니다."
        path="/group-inquiry"
        jsonLd={breadcrumbJsonLd([
          { name: '홈', path: '/' },
          { name: '단체·기관 법률 자문 계약', path: '/group-inquiry' },
        ])}
      />
      <div className={styles.topBar}>
        <div className="wrap">
          <Link to="/" className={styles.back}>
            ← 홈으로
          </Link>
        </div>
      </div>

      <header className={styles.header}>
        <div className="wrap">
          <h1 className={styles.title}>단체·기관 법률 자문 계약</h1>
          <p className={styles.desc}>
            의사회, 전문학회, 네트워크 의원 본사 등 의료인 단체를 위한 맞춤형 법률 자문 계약입니다.
            <br />
            규모와 필요에 따라 조건을 협의해 드립니다.
          </p>
        </div>
      </header>

      <section className={styles.body}>
        <div className="wrap">
          {submitted ? (
            <div className={styles.thanks}>
              <h2 className={styles.thanksTitle}>문의가 접수되었습니다</h2>
              <p className={styles.thanksDesc}>담당자가 1영업일 이내 연락드리겠습니다.</p>
              <Link to="/" className={styles.thanksBack}>
                홈으로 돌아가기
              </Link>
            </div>
          ) : (
            <div className={styles.layout}>
              <div>
                {errorMessage && (
                  <div className={styles.errorBanner} role="alert">
                    제출 실패: {errorMessage}
                  </div>
                )}
                <GroupForm onSubmit={handleSubmit} isSubmitting={isSubmitting} />
              </div>
              <GroupSidePanel />
            </div>
          )}
        </div>
      </section>
    </main>
  );
}
